export default __webpack_public_path__ + "static/media/containers-blue.e4f70e4e.jpg";